export enum TransportationColumnCardsEnums {
  ROAD = 'road',
  ROAD_AIR_ROAD = 'road-air-road',
  ROAD_SEA_ROAD = 'road-sea-road',
  GREEN = 'green',
  BLUE = 'blue',
  YELLOW = 'yellow',
  ORANGE = 'orange',
  RED = 'red',
}
